module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei1.svg";